var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAddFriend = function SvgIconAddFriend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25032 11.125C2.87532 11.875 0.875324 13.75 0.125324 16.25C-0.124676 17 0.500323 17.5 1.25032 17.875C3.25032 18.625 12.2503 18.625 15.1253 17.875C15.8753 17.625 16.5003 17 16.2503 16.25C15.3753 13.875 13.5003 12 11.0003 11.25",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.75C3 8.10923 3.53995 9.4128 4.50108 10.3739C5.4622 11.335 6.76577 11.875 8.125 11.875C9.48423 11.875 10.7878 11.335 11.7489 10.3739C12.71 9.4128 13.25 8.10923 13.25 6.75C13.25 5.39077 12.71 4.0872 11.7489 3.12608C10.7878 2.16495 9.48423 1.625 8.125 1.625C6.76577 1.625 5.4622 2.16495 4.50108 3.12608C3.53995 4.0872 3 5.39077 3 6.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.75H17.625V7.375H16.5V9.75H14.125V10.875H16.5V13.25H17.625V10.875H20V9.75Z",
    fill: "white"
  })));
};
export default SvgIconAddFriend;